import clsx from "clsx";
import { useParams } from "react-router-dom";
import { Filters } from "../../../../lib/filters";
import { CompaniesHorizontalFilters } from "../../../../lib/filters/accordion/horizontalFiltersCompany";
import { ContactType, FindAllContactsFilters, FindContactsDatabaseResponse } from "../../../../lib/filters/dto";
import { initialStateContactsFilters } from "../../../../lib/filters/filtersSlice";
import { useAppSelector } from "../../../../lib/redux/hooks";
import { DatabaseSection, TargetSection } from "../../../../lib/utils";
import { ItemsPerPageValues } from "../../../../ui/organisms/pagination/dto";
import { ContactStateEnum, stateInfoMap } from "../../../targetList/dto";
import { EditCompany } from "../editCompany";
import { CompaniesList } from "./list";

interface Props {
  setSelectedIds: (ids: string[]) => void
  selectedIds: string[]

  section: DatabaseSection | TargetSection
  contacts: FindContactsDatabaseResponse<ContactType.COMPANY>
  onPageChange: (page: number) => void
  onItemsPerPageChange: (itemsPerPage: ItemsPerPageValues) => void
  filters: FindAllContactsFilters
  onChangeFilters: (filters: Partial<FindAllContactsFilters>) => void
  toActivate: number
}

export function Companies(props: Props) {
  const { setSelectedIds, selectedIds, section, contacts, onPageChange, onItemsPerPageChange, filters, onChangeFilters, toActivate } = props
  const databaseState = useAppSelector((state) => state.database);

  const { contactId } = useParams()

  return (
    <div className="max-h-full flex" style={{ height: 'calc(100%)' }}>
      <div className="flex" style={{ width: 'calc(100%)' }}>
        <div
          className={clsx("transition-all duration-300 w-[20%] h-full opacity-100 rounded-bl-xl", {
            flex: databaseState.filtersActive,
            hidden: !databaseState.filtersActive,
          })}
        >
          <Filters
            section={section}
            contactType={ContactType.COMPANY}
            isInTargetList={false}
            resetFilters={() => { onChangeFilters(initialStateContactsFilters['database'][ContactType.COMPANY]) }}
            updateFilters={(newFilters) => onChangeFilters({ ...filters, ...newFilters })}
            filters={filters}
          />
        </div>
        <div
          className={clsx({
            "w-full": !databaseState.filtersActive,
            "w-4/5": databaseState.filtersActive,
          })}
        >
          <div className="h-full max-h-full">
            <CompaniesHorizontalFilters
              onChangeFilters={onChangeFilters}
              filters={filters}
              isInTargetList={false}
              toActivate={toActivate}
            />
            {
              section === "verify-list" && <div className="px-4 py-2 border-b border-neutral-200 flex items-center gap-2">
                {stateInfoMap(ContactStateEnum.INCORRECT).filter(value => value !== "Info errate e aggiornate").map((reason, index) => (
                  <div
                    onClick={() => {
                      if (filters.toVerifyOutcomes && filters.toVerifyOutcomes.map(value => value.value).includes(reason))
                        onChangeFilters({ ...filters, toVerifyOutcomes: filters.toVerifyOutcomes.filter(outcome => outcome.value !== reason) })

                      else
                        onChangeFilters({ ...filters, toVerifyOutcomes: [...filters.toVerifyOutcomes!, { value: reason, label: reason }] });
                    }}
                    className={clsx("cursor-pointer flex items-center h-full px-2 py-1 gap-2 rounded-[4px] bg-neutral-200", {
                      'border-[2px] border-neutral-600': filters.toVerifyOutcomes && filters.toVerifyOutcomes?.map(value => value.value).includes(reason),
                    })}
                  >
                    <span className="text-neutral-800 text-label-sm font-medium whitespace-nowrap">
                      {reason}
                    </span>
                  </div>
                ))}
              </div>
            }
            <CompaniesList
              selectedIds={selectedIds}
              setSelectedIds={setSelectedIds}
              section={section}
              contacts={contacts}
              onPageChange={onPageChange}
              onItemsPerPageChange={onItemsPerPageChange}
              onChangeFilters={onChangeFilters}
              filters={filters}
            />
          </div>
        </div>
      </div>
      <EditCompany section={section} listIndex={contacts?.data?.findIndex(contact => contact.id === contactId)} />
    </div>
  );
}
